module.exports = "https://www.gc-pro.gnp.com.mx/19a6b5d004e16922c1a47ba244f4feab.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/mascota.svg
// module id = 1850
// module chunks = 0